import {autobind, debounce} from 'core-decorators';

@autobind
export default class BaseAdapter {
    static API_TIMEOUT = 30000;
    static CHECK_INTERVAL = 50;
    static SYNCING_INTERVAL = 50;

    static STATES = {
        Buffering: 'Buffering',
        Paused: 'Paused',
        Playing: 'Playing',
        Seek: 'Seek',
        Ended: 'Ended',
    };

    async initialize(options) {
        this.provider = options.provider;
        this.videoId = options.videoId;
        this.videoNode = options.videoNode;
        this.setDuration = options.setVideoDuration;
        this.setDimensions = options.setVideoDimensions;
        this.setPlayerState = options.setPlayerState;
        this.setPlayhead = options.setPlayhead;

        await this.loadAPI();
        if (!options.domContainer) this.prepareVideoNode();

        this.updateVideoDimensions();
        window.addEventListener('resize', this.updateVideoDimensions);

        await this.attach();
    }

    prepareVideoNode() {
        this.videoNode.style.display = 'block';
    }

    getOptions() {
        return undefined;
    }

    @debounce(300)
    updateVideoDimensions() {
        const [width, height] = this.getVideoDimensions();
        if (width && height) this.setDimensions(width, height);
    }

    getVideoDimensions() {
        return [this.videoNode.clientWidth, this.videoNode.clientHeight];
    }

    getVideoTitle() {
        throw new Error('Not implemented');
    }

    getMetadata() {
        return Promise.resolve({
            title: '',
            description: '',
            contentUrL: '',
            thumbnailUrl: '',
            uploadDate: '',
        });
    }

    attach() {
        throw new Error('Not implemented');
    }

    seek() {
        throw new Error('Not implemented');
    }

    pause() {
        throw new Error('Not implemented');
    }

    toMS(value) {
        return value * 1000;
    }

    toSS(value) {
        return value / 1000;
    }
}



// WEBPACK FOOTER //
// ./scripts/adapters/base.js